<template>
	<div class="cloud-videoMonitoring">
		<div class="cloud-videoMonitoring-l">
			<div class="cloud-videoMonitoring-title">
				<div class="cloud-videoMonitoring-title-title">
					<img src="@/assets/images/groupTitle.png" alt="" style="width: 100%; height: 4vh;" />
					<p>方案交底管理</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '8%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 88%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-videoMonitoring-title-content">
					<FixedTree :treeData="treeData" />
				</div>
			</div>
		</div>

		<div class="cloud-videoMonitoring-r">
			<div class="cloud-videoMonitoring-title" style="width: 100%; ">
				<div class="cloud-videoMonitoring-title-title">
					<img src="@/assets/images/groupTitlec.png" alt="" style="width: 100%; height: 4vh;" />
					<p>方案交底详细内容</p>
					<dv-decoration-3 class="decoration-container" :style="{ width: '3%', height: '30px' }"
						style="position: absolute; top: 1px; margin-left: 96%;">
						<!-- 插槽中添加多个小方块 -->
						<div slot="content" class="squares-container">
							<div class="square s1"></div>
							<div class="square s2"></div>
							<div class="square s3"></div>
							<div class="square s4"></div>
							<div class="square s5"></div>
							<div class="square s6"></div>
						</div>
					</dv-decoration-3>
				</div>
				<div class="cloud-videoMonitoring-title-content" style="overflow-y: hidden;">
					<iframe v-if="isShowHteml === true" style="width: 100%; height: 100%; border: #003659 0px solid; margin-top: 3vh;"
						:src="BX_5_M"></iframe>
					<Hteml v-else style="width: 100%; height: 100%; text-align: left; overflow-y: auto;" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import FixedTree from '../../components/FixedTree.vue'
import Hteml from '../../components/home/HtemlView.vue'
const BX_5_M = require('@/assets/pdf/test.pdf')

// 引入路由实例
export default {
	name: 'schemeDisclosure',
	components: {
		FixedTree,
		Hteml
	},
	data() {
		return {
			BX_5_M,
			isShowHteml: window.location.hostname === '39.101.122.159' ? true : false ,
			pathSrc: window.location.hostname === '39.101.122.159' ? 'http://'+window.location.hostname+':19001/prod-api' :'http://'+window.location.hostname+':10181/stage-api',
			currentVideoSrc: '',
			urlType: 1,
			treeData: [
				{
					id: 1,
					label: '掌子面材料机具摆放架',
					expanded: true, // 控制是否展开
					active: false,  // 控制是否选中
					children: [
						{
							id: 11,
							label: '仰拱初支钢端模',
							expanded: true,
							active: false,
							children: [
								{ id: 111, label: '激光标线器', active: false },
								{ id: 112, label: '盲管固定工装', active: false }
							]
						},
						{
							id: 12,
							label: '喷射混凝土“三喷两刮两检”工艺工装',
							expanded: false,
							active: false,
							children: [
								{ id: 121, label: '仰拱钢筋卡具', active: false }
							]
						}
					]
				}
			]
		}
	},
	computed: {

	},
	mounted() {

	},
	methods: {

	},
	beforeDestroy() {

	}
}
</script>
<style scoped>
/* 引入字体 */
@font-face {
	font-family: 'DS-Digital';
	src: url('../font/DS-DIGIB.TTF') format('truetype');
	font-weight: normal;
	font-style: normal;
}

.cloud-videoMonitoring {
	width: 100%;
	height: 100%;
	text-align: left;

	>.cloud-videoMonitoring-l {
		position: relative;
		width: calc(400 / 1920 * 100vw);
		height: calc(920 / 1080 * 100vh);
		left: 1vw;
		top: 1vh;
		float: left;
		overflow: hidden;
		border-radius: 20px;
	}

	>.cloud-videoMonitoring-r {
		position: relative;
		width: calc(1470 / 1920 * 100vw);
		height: calc(920 / 1080 * 100vh);
		top: 1vh;
		margin-left: 1.8vw;
		float: left;
		overflow: hidden;
		border-radius: 20px;
	}

	.cloud-videoMonitoring-title {
		position: absolute;
		top: 1vh;
		left: 0;
		width: 100%;
		height: calc(920 / 1080 * 100vh);
		background: rgba(0, 0, 0, 0.4);
		border-radius: 10px;

		.cloud-videoMonitoring-title-title {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: 2.5vh;
			margin: 0;
			padding: 0;

			img {
				width: 100%;
				height: auto;
				margin: 0;
				padding: 0;
			}

			p {
				position: absolute;
				top: 0.3vh;
				left: 3.01vh;
				width: 100%;
				height: 2.5vh;
				margin: 0;
				padding: 0;
				font-size: 1.0rem;
				color: #fff;
				text-align: left;
			}
		}

		.cloud-videoMonitoring-title-content {
			position: relative;
			top: 0px;
			left: 0px;
			width: 100%;
			height: calc(870 / 1080 * 100vh);
			margin: 0;
			padding: 0;
			overflow-y: auto;
			scrollbar-width: thin;
			scrollbar-color: rgba(150, 150, 150, 0.2) transparent;
		}
	}


}
</style>